// extracted by mini-css-extract-plugin
export default {"Contacts":"Contacts_Contacts__341tB","Website":"Contacts_Website__vB4BO","Address":"Contacts_Address__SYdmE"};